import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { PriceInputWrapper, Option, SwitchIconWrapper } from './PriceInput.style';
import { useAppStateContext } from 'src/appState/AppState';
import { BetslipSingleId } from 'src/domains/sportsbook/betting/models/BetslipIdModels';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';

interface PriceInputType {
    selectionId: BetslipSingleId;
}

export const PriceInput = observer('PriceInput', ({ selectionId }: PriceInputType): JSX.Element | null => {
    const appState = useAppStateContext();
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const legModel = selectionId.getModel();
    const { isReferred } = AppSportsBookState.get(appState.common).betSlipState.referralState;

    if (legModel.priceOptions !== undefined) {
        const label = legModel.selectedPriceType;
        return (
            <PriceInputWrapper
                variant={configState.componentVariants.inputVariant}
                priceDirection={isReferred ? null : legModel.selectionChangedDirection}
                onClick={legModel.handleSwitchPriceType}
            >
                <Option variant={configState.componentVariants.betslipVariant}>{label}</Option>
                {!legModel.switchDisabled && <SwitchIconWrapper />}
            </PriceInputWrapper>
        );
    }
    return null;
});
